"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f119 = void 0;
exports.f119 = {
    "wawenock": [
        23
    ],
    "wambon": [
        8282,
        28
    ],
    "western": [
        307,
        308,
        309,
        310,
        36,
        391,
        440,
        605,
        790,
        791,
        1103,
        1104,
        1105,
        1106,
        1478,
        1479,
        1480,
        1669,
        1928,
        2404,
        2486,
        2488,
        2721,
        2995,
        3107,
        3399,
        3709,
        3719,
        3946,
        4019,
        4152,
        4153,
        4154,
        4162,
        4199,
        4200,
        4249,
        4287,
        4601,
        4890,
        4891,
        4918,
        5042,
        5143,
        5464,
        5868,
        5869,
        6227,
        6354,
        6380,
        6458,
        7140,
        7189,
        7303,
        7390,
        7391,
        7616,
        8203,
        8276,
        8387,
        8697,
        8798,
        8947,
        8970,
        108,
        109,
        110,
        382,
        548,
        569,
        733,
        849,
        960,
        1278,
        1306,
        1595,
        1610,
        1611,
        1856,
        1857,
        1921,
        2016,
        2251,
        2329,
        2503,
        2837,
        2838,
        3064,
        3186,
        3187,
        3270,
        3373,
        3516,
        3559,
        3969,
        4300,
        4301,
        4518,
        4624,
        4724,
        4807,
        5049,
        5266,
        5431,
        5620,
        5621,
        5666,
        5714,
        5989,
        6265,
        6595,
        6855,
        6856,
        7066,
        7643,
        7680,
        7691,
        7819,
        7853,
        8020,
        8103,
        8398,
        8399,
        8514,
        8564,
        8719,
        8790,
        8952,
        8973,
        8974,
        9127,
        9128,
        9138,
        9142,
        9165,
        582,
        2487,
        2810,
        3827,
        4196,
        4197,
        4198,
        7882,
        412
    ],
    "western abnaki": [
        36
    ],
    "wagama": [
        38
    ],
    "wagaba": [
        38
    ],
    "wosera": [
        53,
        8319
    ],
    "wake": [
        58
    ],
    "winterwiek": [
        78
    ],
    "west arabian colloquial arabic": [
        81
    ],
    "west": [
        8103,
        8190,
        649,
        702,
        1775,
        1961,
        2349,
        3581,
        4402,
        5027,
        5091,
        5594,
        7849,
        8748,
        8749,
        9002,
        81,
        108,
        109,
        110,
        239,
        552,
        1600,
        1614,
        1652,
        2329,
        2495,
        2563,
        2770,
        2997,
        2998,
        3107,
        3298,
        3659,
        3817,
        4367,
        4382,
        4918,
        5220,
        5272,
        5431,
        5734,
        5956,
        7167,
        7371,
        7864,
        7876,
        8033,
        8114,
        8215,
        8319,
        175,
        2649,
        4721,
        5900,
        5902,
        6482,
        7010
    ],
    "waiwerang": [
        101
    ],
    "wailbi": [
        104
    ],
    "wailpi": [
        104
    ],
    "waljbi": [
        104
    ],
    "wipie": [
        104
    ],
    "west circassian": [
        108,
        109,
        110
    ],
    "western adyghe": [
        108,
        109,
        110
    ],
    "western circassian": [
        108,
        109,
        110
    ],
    "wangkai": [
        137
    ],
    "wɨrkŋɨ": [
        141
    ],
    "wan": [
        8161,
        156,
        518,
        7999,
        6523
    ],
    "watapor": [
        156
    ],
    "wum": [
        166
    ],
    "wanoni": [
        172,
        7171
    ],
    "waawilûû": [
        222
    ],
    "wai": [
        222,
        8171,
        8182
    ],
    "wailu": [
        222
    ],
    "waicá": [
        236,
        8194
    ],
    "waika": [
        236
    ],
    "wage": [
        239
    ],
    "west angal heneng": [
        239
    ],
    "west mendi": [
        239
    ],
    "wama": [
        245,
        8375
    ],
    "wayaricuri": [
        245
    ],
    "warliburru": [
        263
    ],
    "wardadjbak": [
        291
    ],
    "woraidbug": [
        291
    ],
    "wureidbug": [
        291
    ],
    "war-jaintia": [
        296
    ],
    "war": [
        296,
        5172
    ],
    "war-khasi": [
        296
    ],
    "wakitaneri": [
        302
    ],
    "wintaperi": [
        302
    ],
    "western neo-aramaic": [
        307,
        308,
        309,
        310
    ],
    "wanindilyaugwa": [
        352
    ],
    "weri": [
        359,
        8211
    ],
    "western timbira": [
        382
    ],
    "western apache": [
        391
    ],
    "world": [
        2026,
        406,
        536,
        1316,
        2119,
        2243,
        3110,
        3144,
        3162,
        3163,
        3227,
        3331,
        3724,
        4262,
        4294,
        4295,
        5136,
        5407,
        5637,
        6288,
        6449,
        6450,
        6451,
        6452,
        6562,
        6897,
        6898,
        7566,
        7567,
        7883,
        7969,
        8131,
        8794,
        8996,
        8999,
        9180
    ],
    "western sahara": [
        412
    ],
    "western arrarnta": [
        440
    ],
    "wamais": [
        470
    ],
    "wamayi": [
        470
    ],
    "wasi": [
        485,
        8181
    ],
    "waimiri-atroarí": [
        501
    ],
    "waimiri-atroari": [
        501
    ],
    "white clay people": [
        502
    ],
    "white": [
        4551,
        502,
        711,
        712,
        713,
        1859,
        3050,
        3976,
        3977,
        4061,
        4062,
        5197,
        5198,
        5199,
        5200,
        5201,
        7825,
        7826,
        7872,
        7873,
        8884,
        8913,
        2655
    ],
    "waorani": [
        512
    ],
    "wao tededö": [
        512
    ],
    "wao": [
        512
    ],
    "wao terero": [
        512
    ],
    "wao tiriro": [
        512
    ],
    "waodäni": [
        512
    ],
    "waodäni tededö": [
        512
    ],
    "waos": [
        512
    ],
    "waotededo": [
        512
    ],
    "wan wan": [
        518
    ],
    "wanib": [
        518
    ],
    "western acipa": [
        548
    ],
    "wimaranga": [
        550
    ],
    "wimarangga": [
        550
    ],
    "wimarango": [
        550
    ],
    "wimmarango": [
        550
    ],
    "west awin": [
        552
    ],
    "western aranda": [
        569
    ],
    "western egyptian bedawi spoken arabic": [
        582
    ],
    "western durango aztec": [
        605
    ],
    "western durango nahuatl": [
        605
    ],
    "workai": [
        617
    ],
    "waimaha": [
        623,
        8277
    ],
    "waimaja": [
        623
    ],
    "waimajã": [
        623
    ],
    "waimasa": [
        623
    ],
    "waymasa": [
        623
    ],
    "waípinõmakã": [
        623
    ],
    "watulai": [
        632
    ],
    "west central banda": [
        649
    ],
    "wudufu": [
        653
    ],
    "wuufu": [
        653
    ],
    "wo": [
        654,
        1118
    ],
    "wurkum": [
        654,
        3984,
        6164
    ],
    "wovea": [
        657
    ],
    "wuvia": [
        657
    ],
    "west coast bajao": [
        702
    ],
    "west coast bajau": [
        702
    ],
    "west coast bajaw": [
        702
    ],
    "white russian": [
        711,
        712,
        713
    ],
    "white ruthenian": [
        711,
        712,
        713
    ],
    "wemba": [
        8701,
        727,
        728
    ],
    "western bété": [
        733
    ],
    "wonana": [
        749
    ],
    "western balochi": [
        790,
        791
    ],
    "warkay-bipim": [
        799
    ],
    "wakatobi": [
        825,
        3647
    ],
    "wós kovedi": [
        832
    ],
    "wós": [
        832
    ],
    "wós vyak": [
        832
    ],
    "widimaya": [
        837
    ],
    "western bila": [
        849
    ],
    "wogu": [
        865
    ],
    "warabal": [
        884
    ],
    "wa": [
        6291,
        8186,
        928,
        929,
        930,
        931,
        3122,
        4770,
        8032,
        8146
    ],
    "wurung balantak": [
        940
    ],
    "wurung": [
        940,
        7531
    ],
    "wule": [
        960,
        1022
    ],
    "western bobo oule": [
        960
    ],
    "western bobo wule": [
        960
    ],
    "western bwamu": [
        960
    ],
    "western red": [
        960
    ],
    "wei": [
        997,
        999,
        1000,
        1001,
        8225
    ],
    "weizang": [
        997,
        999,
        1000,
        1001
    ],
    "wen": [
        3542,
        997,
        1000,
        1001
    ],
    "waboni": [
        1003
    ],
    "wata-bala": [
        1003
    ],
    "wadáru": [
        1017
    ],
    "warapu": [
        1029
    ],
    "wumboko": [
        1062
    ],
    "womboko": [
        1062
    ],
    "wachi": [
        1071,
        8195
    ],
    "wabira": [
        1083
    ],
    "wowo": [
        1088
    ],
    "western bru": [
        1103
    ],
    "wushi": [
        1119
    ],
    "wushike": [
        1119
    ],
    "werinama": [
        1168
    ],
    "wakuenai": [
        1230
    ],
    "walimanai": [
        1230
    ],
    "wunai": [
        1235
    ],
    "wunai bunu": [
        1235
    ],
    "western chepang": [
        1278
    ],
    "waran": [
        1295
    ],
    "western caribbean creole": [
        1306,
        3064
    ],
    "wariagar": [
        1312
    ],
    "widi": [
        1314
    ],
    "wierdi": [
        1314
    ],
    "wirdi": [
        1314
    ],
    "wiri": [
        1314,
        2014,
        8562
    ],
    "wiriwiri": [
        1314
    ],
    "wirri": [
        1314
    ],
    "wu": [
        8369,
        8370,
        8371,
        8032,
        1318
    ],
    "wagap": [
        1340
    ],
    "weranos": [
        1355
    ],
    "wacara": [
        1368
    ],
    "woods mari": [
        1447,
        1448
    ],
    "woods": [
        1447,
        1448,
        1596,
        1597
    ],
    "wawa": [
        8379,
        1449,
        1450,
        1496,
        1497,
        1498
    ],
    "warapiche": [
        1477
    ],
    "western cham": [
        1478,
        1479,
        1480
    ],
    "wenatchee": [
        1570
    ],
    "wenatchi": [
        1570
    ],
    "wenatchi-columbia": [
        1570
    ],
    "wamey": [
        1579
    ],
    "wameỹ": [
        1579
    ],
    "wamay": [
        1579
    ],
    "wamei": [
        1579
    ],
    "wey": [
        1579
    ],
    "western miao": [
        1595
    ],
    "west ambrym": [
        1600
    ],
    "western cree": [
        1610,
        1611
    ],
    "west main cree": [
        1614,
        1652
    ],
    "west shore cree": [
        1614,
        1652
    ],
    "western highland chatino": [
        1669
    ],
    "wayanad": [
        1671
    ],
    "wayanad chetti": [
        1671
    ],
    "waistband": [
        1694
    ],
    "wong": [
        1706
    ],
    "welsh": [
        1708,
        1709,
        6006,
        6563,
        8262
    ],
    "walo": [
        1766
    ],
    "west goodenough": [
        1775
    ],
    "wawari": [
        1776
    ],
    "wina": [
        1810,
        7045,
        7791
    ],
    "wira": [
        1810
    ],
    "wirã": [
        1810
    ],
    "wala": [
        4305,
        1816,
        8269
    ],
    "wa’a": [
        1819
    ],
    "wurrung": [
        1830,
        1868,
        2661,
        7531,
        8354
    ],
    "war-ramirri": [
        1833
    ],
    "warameri": [
        1833
    ],
    "waramiri": [
        1833
    ],
    "warramiri": [
        1833
    ],
    "warumeri": [
        1833
    ],
    "warki": [
        1854
    ],
    "warkimbe": [
        1854
    ],
    "western dinka": [
        1856,
        1857
    ],
    "white nile dinka": [
        1859
    ],
    "wasare": [
        1884
    ],
    "western rote": [
        1921,
        6595,
        7853
    ],
    "western dani": [
        1928
    ],
    "west damar": [
        1961
    ],
    "wendish": [
        1968,
        3058
    ],
    "witu": [
        8241,
        2015,
        8242
    ],
    "western duun": [
        2016
    ],
    "wulamba": [
        2027
    ],
    "ws": [
        2223,
        6962
    ],
    "western gyarong": [
        2251
    ],
    "western jiarong": [
        2251,
        3373
    ],
    "wesrau": [
        2315
    ],
    "west persian": [
        2329
    ],
    "western farsi": [
        2329
    ],
    "wagi": [
        2333
    ],
    "waro": [
        2343
    ],
    "west albay bikol": [
        2349
    ],
    "wikang filipino": [
        2387,
        2388
    ],
    "wikang": [
        2387,
        2388,
        7556,
        7557,
        7558,
        7559
    ],
    "walmbaria": [
        2400
    ],
    "wurima": [
        2400
    ],
    "withi": [
        2402
    ],
    "wf": [
        2464,
        2481,
        8265
    ],
    "wallis and futuna": [
        2464,
        2481,
        8265
    ],
    "wallis": [
        2464,
        2481,
        8265
    ],
    "western niger fulfulde": [
        2486,
        2487,
        2488
    ],
    "west futuna-aniwa": [
        2495
    ],
    "western frisian": [
        2503
    ],
    "westlauwers fries": [
        2503
    ],
    "westlauwers": [
        2503
    ],
    "warekena": [
        2512
    ],
    "werekena": [
        2512
    ],
    "werikena": [
        2512
    ],
    "weim": [
        2527
    ],
    "west gwari": [
        2563
    ],
    "wipi": [
        2592
    ],
    "wegele": [
        2602
    ],
    "wunci": [
        2632
    ],
    "wuncimbe": [
        2632
    ],
    "white gelao": [
        2655
    ],
    "warrnambool": [
        2661
    ],
    "weeritch-weeritch": [
        2661
    ],
    "wangara": [
        2671
    ],
    "wanggara": [
        2671
    ],
    "wakura": [
        2686
    ],
    "widala": [
        2690,
        3984
    ],
    "wadeawulu": [
        2711
    ],
    "wokka": [
        2718
    ],
    "wartha thuntai": [
        2719
    ],
    "wartha": [
        2719
    ],
    "warta thuntai": [
        2719
    ],
    "warta": [
        2719
    ],
    "western bolivian guaraní": [
        2721
    ],
    "wagogo": [
        2730
    ],
    "west guadalcanal": [
        2770
    ],
    "wedebo grebo": [
        2785
    ],
    "wedebo": [
        2785
    ],
    "wasembo": [
        2793
    ],
    "wayuu": [
        2805
    ],
    "wayuunaiki": [
        2805
    ],
    "wahiro": [
        2805
    ],
    "waiu": [
        2805
    ],
    "wayu": [
        8064,
        2805
    ],
    "wayúu": [
        2805
    ],
    "wurlayi": [
        2807
    ],
    "wahibo": [
        2809
    ],
    "wahivo": [
        2809
    ],
    "western argentine guaraní": [
        2810
    ],
    "wanano": [
        2828
    ],
    "wanana": [
        2828
    ],
    "wanana-pirá": [
        2828,
        6157
    ],
    "wanâna": [
        2828
    ],
    "waing": [
        2829
    ],
    "wazaizara": [
        2831
    ],
    "western gurung": [
        2837,
        2838
    ],
    "wunambal": [
        8361,
        2855
    ],
    "wè southern": [
        2857
    ],
    "wè": [
        2857,
        8203,
        8305
    ],
    "wèè": [
        2857,
        8203,
        8305
    ],
    "wixárika": [
        2917
    ],
    "wahehe": [
        2925
    ],
    "waha": [
        2937
    ],
    "wabui": [
        2954
    ],
    "watut": [
        2992,
        4649,
        4995,
        7968
    ],
    "western mashan hmong": [
        2995
    ],
    "western mashan miao": [
        2995
    ],
    "waishu miao": [
        2997,
        2998
    ],
    "waishu": [
        2997,
        2998
    ],
    "water miao": [
        2997,
        2998
    ],
    "water": [
        2997,
        2998
    ],
    "west of the water miao": [
        2997,
        2998
    ],
    "wooden comb miao": [
        2997,
        2998
    ],
    "wooden": [
        2997,
        2998
    ],
    "woni": [
        3037
    ],
    "white miao": [
        3050,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "warwar feni": [
        3055
    ],
    "warwar": [
        3055,
        6905
    ],
    "witoto, minika": [
        3066
    ],
    "witoto": [
        3066,
        3090,
        3093
    ],
    "witoto meneca": [
        3066
    ],
    "watindiga": [
        3067
    ],
    "wampís": [
        3072
    ],
    "wambisa": [
        3072
    ],
    "wachipaeri": [
        3077
    ],
    "wacipaire": [
        3077
    ],
    "witoto, murui": [
        3090
    ],
    "witoto, muinani": [
        3093
    ],
    "witoto, nipode": [
        3093
    ],
    "wané": [
        3101
    ],
    "west armenian": [
        3107
    ],
    "western armenian": [
        3107
    ],
    "wa bambani": [
        3122
    ],
    "wagoi": [
        3122
    ],
    "western canada inuktun": [
        3186,
        3187
    ],
    "western canadian inuit": [
        3186,
        3187
    ],
    "western canadian inuktitut": [
        3186,
        3187
    ],
    "western itelmen": [
        3270
    ],
    "western kamchadal": [
        3270
    ],
    "warri": [
        3274
    ],
    "west teke": [
        3298,
        4382,
        7864,
        7876
    ],
    "wadiri": [
        3317
    ],
    "winjawindjagu": [
        3335
    ],
    "wembi": [
        3353
    ],
    "western juxtlahuaca mixtec": [
        3399
    ],
    "wojenaka": [
        3411
    ],
    "wiyap": [
        3422
    ],
    "wannu": [
        3427
    ],
    "worodougou": [
        3429
    ],
    "worodougou jula": [
        3429
    ],
    "worodougoukakan": [
        3429
    ],
    "worodugu": [
        3429
    ],
    "wüödughukakan": [
        3429
    ],
    "weera": [
        3431
    ],
    "werra": [
        3431
    ],
    "wiramaya": [
        3431
    ],
    "wirameju": [
        3431
    ],
    "wirameyu": [
        3431
    ],
    "wirra": [
        3431
    ],
    "wirra-maya": [
        3431
    ],
    "wirramaya": [
        3431
    ],
    "wirramayo": [
        3431
    ],
    "wirrameyu": [
        3431
    ],
    "wapan": [
        3432
    ],
    "wukari": [
        3432
    ],
    "wakari": [
        3432
    ],
    "wapã": [
        3432
    ],
    "wadega": [
        3434
    ],
    "wadkai": [
        3434
    ],
    "wãpha": [
        3442
    ],
    "wase": [
        3442
    ],
    "wase tofa": [
        3442
    ],
    "warikiana": [
        3479
    ],
    "warikyana": [
        3479
    ],
    "wakalanga": [
        3516
    ],
    "western shona": [
        3516
    ],
    "wakami": [
        3526
    ],
    "worimi": [
        3532
    ],
    "warimi": [
        3532
    ],
    "western kele": [
        3559
    ],
    "west kewa": [
        3581
    ],
    "west songhoy": [
        3659
    ],
    "wihә": [
        3681
    ],
    "welam": [
        3691
    ],
    "wambo": [
        3694,
        3695
    ],
    "western parbate": [
        3709
    ],
    "western parbate kham": [
        3709
    ],
    "west-central": [
        3718,
        4324,
        3713,
        3714,
        3715,
        3716,
        3717
    ],
    "western keres": [
        3719
    ],
    "western keres pueblo": [
        3719
    ],
    "wanam": [
        3748
    ],
    "weliki": [
        3771
    ],
    "weleki": [
        3771
    ],
    "washkuk": [
        3807
    ],
    "wand tuan": [
        3810
    ],
    "wand": [
        3810
    ],
    "waboda": [
        3815
    ],
    "wabuda": [
        3815
    ],
    "west khorasani turkic": [
        3817
    ],
    "west xorasan turkic": [
        3817
    ],
    "western kanjobal": [
        3827
    ],
    "western q’anjob’al": [
        3827
    ],
    "waninnawa": [
        3840
    ],
    "waia": [
        3842
    ],
    "waya": [
        3842
    ],
    "waube": [
        3864
    ],
    "waupe": [
        3864
    ],
    "wegam": [
        3870
    ],
    "wakuénai": [
        3875
    ],
    "waquenia": [
        3875
    ],
    "western krahn": [
        3946
    ],
    "western kran": [
        3946
    ],
    "western kaba": [
        3969
    ],
    "winyé": [
        3973
    ],
    "white karen": [
        3976,
        3977,
        4061,
        4062
    ],
    "wanggamadu": [
        3985
    ],
    "wongamardu": [
        3985
    ],
    "wambon-ketum": [
        4000
    ],
    "western katu": [
        4019
    ],
    "wohta": [
        4065
    ],
    "warilau": [
        4067
    ],
    "wersing": [
        4068
    ],
    "warsina": [
        4068
    ],
    "wersin": [
        4068
    ],
    "welakau": [
        4076
    ],
    "wadiyari": [
        4115,
        4116,
        4117
    ],
    "wadaria": [
        4115,
        4116,
        4117
    ],
    "wadhiara": [
        4115,
        4116,
        4117
    ],
    "wadiyara": [
        4115,
        4116,
        4117
    ],
    "wadiyara koli": [
        4115,
        4116,
        4117
    ],
    "wapatu": [
        4143
    ],
    "wiyagar": [
        4151,
        7361
    ],
    "western kayah": [
        4152,
        4153,
        4154
    ],
    "western karaboro": [
        4162
    ],
    "western panjabi": [
        4196,
        4197,
        4198,
        4199,
        4200
    ],
    "wampar": [
        4232
    ],
    "wayapo": [
        4247
    ],
    "western lawa": [
        4249
    ],
    "wapi pii": [
        4282
    ],
    "wapi": [
        4282,
        6235
    ],
    "walese": [
        4284
    ],
    "walisi": [
        4284
    ],
    "western lugbara": [
        4300,
        4301
    ],
    "wansum": [
        4310
    ],
    "west-central limba": [
        4324
    ],
    "weela": [
        4331
    ],
    "weila": [
        4331
    ],
    "wiila": [
        4331
    ],
    "west gaua": [
        4367
    ],
    "west lembata": [
        4402
    ],
    "wanji": [
        4406,
        4407,
        4408,
        8180,
        8301
    ],
    "wimbum": [
        4410
    ],
    "wanggamana": [
        4437
    ],
    "wanggamanha": [
        4437,
        8253
    ],
    "wangkamanha": [
        4437
    ],
    "wonggaman": [
        4437
    ],
    "wiang": [
        4439
    ],
    "western luba": [
        4518
    ],
    "whelngo": [
        4533,
        4534,
        4535
    ],
    "wanga": [
        4550
    ],
    "white lachi": [
        4551
    ],
    "western bukidnon": [
        4601
    ],
    "western bukidnon manobo": [
        4601
    ],
    "wamaka": [
        4614
    ],
    "wiwa": [
        4614
    ],
    "western sola de vega mixtec": [
        4624
    ],
    "wanai": [
        4631
    ],
    "wariadai": [
        4652
    ],
    "wuna": [
        4654,
        4934,
        8373
    ],
    "wadai": [
        4655,
        4656
    ],
    "waddayen": [
        4655,
        4656
    ],
    "wambutu": [
        4662
    ],
    "wando": [
        4680
    ],
    "wailemi": [
        4681
    ],
    "wandala": [
        4717,
        4718
    ],
    "wakande": [
        4723
    ],
    "western mbube": [
        4724
    ],
    "widikum-tadkon": [
        4754
    ],
    "wa maathi": [
        4770
    ],
    "wa-ma’a": [
        4770
    ],
    "wama’a": [
        4770
    ],
    "wea": [
        4791
    ],
    "western jamiltepec mixtec": [
        4807
    ],
    "walwana": [
        4884
    ],
    "western malinke": [
        4890,
        4891
    ],
    "western maninkakan": [
        4890,
        4891
    ],
    "west hunan miao": [
        4918
    ],
    "western ghao-xong": [
        4918
    ],
    "western west-hunan miao": [
        4918
    ],
    "west-hunan": [
        4918,
        5139
    ],
    "western xiangxi miao": [
        4918
    ],
    "wangka": [
        4993
    ],
    "wangkajunga": [
        4993
    ],
    "weng": [
        5003
    ],
    "west makian": [
        5027
    ],
    "western magar": [
        5042
    ],
    "western mari": [
        5049
    ],
    "west marsela": [
        5091
    ],
    "west masela": [
        5091
    ],
    "wichí lhamtés nocten": [
        5116
    ],
    "wichí": [
        5116,
        5263,
        8267
    ],
    "weenhayek": [
        5116
    ],
    "western muria": [
        5143
    ],
    "wotaf": [
        5167
    ],
    "wetu": [
        5195
    ],
    "white hmong": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "white lum": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "white meo": [
        5197,
        5198,
        5200
    ],
    "wamanyika": [
        5207
    ],
    "wanyika": [
        5207
    ],
    "waipu": [
        5218
    ],
    "west central mixe": [
        5220
    ],
    "weidyenye": [
        5249
    ],
    "wuhána": [
        5253
    ],
    "wichí lhamtés güisnay": [
        5263
    ],
    "wichí lhamtés": [
        5263
    ],
    "western mambila": [
        5266
    ],
    "west mori": [
        5272
    ],
    "wain": [
        5287
    ],
    "wɛɛn": [
        5390
    ],
    "ween": [
        5390
    ],
    "walomwe": [
        5431
    ],
    "west makhuwa": [
        5431
    ],
    "western makua": [
        5431
    ],
    "wayomba": [
        5434
    ],
    "western huasteca aztec": [
        5464
    ],
    "western huasteca nahuatl": [
        5464
    ],
    "wate": [
        5480
    ],
    "wanda": [
        8179,
        5495
    ],
    "walangama": [
        5557
    ],
    "wahlongman": [
        5557
    ],
    "wallan-kammer": [
        5557
    ],
    "wallenkammer": [
        5557
    ],
    "wollangama": [
        5557
    ],
    "wollongurmee": [
        5557
    ],
    "weite": [
        5583
    ],
    "west ambae": [
        5594
    ],
    "wancho": [
        5606,
        5607,
        5608
    ],
    "wancho naga": [
        5606,
        5607,
        5608
    ],
    "wallaroo": [
        5613
    ],
    "warra": [
        8338,
        5613,
        8354,
        9071
    ],
    "wongaidya": [
        5613
    ],
    "woun meu": [
        5618
    ],
    "woun": [
        5618
    ],
    "waumeo": [
        5618
    ],
    "waun meo": [
        5618
    ],
    "waun": [
        5618
    ],
    "waunana": [
        5618
    ],
    "waunméu": [
        5618
    ],
    "waunán": [
        5618
    ],
    "woun meo": [
        5618
    ],
    "wounaan": [
        5618
    ],
    "wounaan meu": [
        5618
    ],
    "wounmeu": [
        5618
    ],
    "western laotian": [
        5620,
        5621
    ],
    "wintun": [
        5629,
        6377,
        8300
    ],
    "wintu": [
        8300,
        5629,
        6377
    ],
    "western rengma": [
        5666
    ],
    "wapumni": [
        5709
    ],
    "western desert language": [
        5714
    ],
    "west coast": [
        5734
    ],
    "wubuy": [
        5750
    ],
    "wes": [
        8212,
        5765
    ],
    "wudjari": [
        5805
    ],
    "western ojibwa": [
        5868,
        5869
    ],
    "western ojibwe": [
        5868,
        5869
    ],
    "walungge": [
        5891
    ],
    "waling": [
        8270,
        5891
    ],
    "walongchung gola": [
        5891
    ],
    "walongchung": [
        5891
    ],
    "walung": [
        5891
    ],
    "walungchung gola": [
        5891
    ],
    "walungchung": [
        5891
    ],
    "walunggi keccya": [
        5891
    ],
    "walunggi": [
        5891
    ],
    "wulgulu": [
        5894
    ],
    "west elema": [
        5956
    ],
    "warmaro": [
        5960
    ],
    "win": [
        5962,
        8228
    ],
    "wazhazhe": [
        5969,
        5970
    ],
    "wazhazhe ie": [
        5969,
        5970
    ],
    "western otomi": [
        5989
    ],
    "wargla": [
        5998
    ],
    "wayampi": [
        6009
    ],
    "wajãpi": [
        6009
    ],
    "waiampi": [
        6009
    ],
    "waiãpi": [
        6009
    ],
    "wajapae": [
        6009
    ],
    "wajapi": [
        6009
    ],
    "wajapuku": [
        6009
    ],
    "wayapae": [
        6009
    ],
    "wayapi": [
        6009
    ],
    "wayãpi": [
        6009
    ],
    "wayãpy": [
        6009
    ],
    "wiraféd": [
        8240,
        6022
    ],
    "wari": [
        7328,
        8177,
        6038
    ],
    "wari’": [
        6038
    ],
    "woromaipu": [
        6048
    ],
    "wotjüja": [
        6145
    ],
    "wo’tiheh": [
        6145
    ],
    "wu’tjuja": [
        6145
    ],
    "wöthüha": [
        6145
    ],
    "wordako": [
        6150
    ],
    "wenewika": [
        6155
    ],
    "wenéwika": [
        6155
    ],
    "waikhara": [
        6157
    ],
    "waikino": [
        6157
    ],
    "waina": [
        6157,
        7045
    ],
    "waíkana": [
        6157
    ],
    "wale": [
        6175
    ],
    "wavaroo": [
        6205
    ],
    "wave veroo": [
        6205
    ],
    "wave": [
        6205
    ],
    "waveroo": [
        6205
    ],
    "wayerroo": [
        6205
    ],
    "waywurru": [
        6205
    ],
    "wayyourong": [
        6205
    ],
    "wayyouroo": [
        6205
    ],
    "weeerroo": [
        6205
    ],
    "weeherroo": [
        6205
    ],
    "western penan": [
        6227
    ],
    "wara": [
        8178,
        6233,
        8338
    ],
    "wariapano": [
        6236
    ],
    "western popoloca": [
        6265
    ],
    "wolastoqewi": [
        6281
    ],
    "wa, parauk": [
        6291
    ],
    "wasi-veri": [
        6294
    ],
    "wasi-weri": [
        6294
    ],
    "wangada": [
        6343
    ],
    "wanggaji": [
        6343
    ],
    "wangkatha": [
        6343
    ],
    "wonga": [
        6343
    ],
    "wongai-i": [
        6343
    ],
    "wonggaii": [
        6343
    ],
    "western highland purepecha": [
        6354
    ],
    "wanse": [
        6361
    ],
    "wãnsöhöt": [
        6361
    ],
    "wanca": [
        6427,
        6448
    ],
    "wanka": [
        6427,
        6448
    ],
    "wanca nunashimi": [
        6427
    ],
    "wanka quechua": [
        6427
    ],
    "western meohang": [
        6458
    ],
    "wiaoe": [
        6485
    ],
    "wiau": [
        6485
    ],
    "wagelak": [
        6527
    ],
    "wawilag": [
        6527
    ],
    "walsenenge kale": [
        6563
    ],
    "walsenenge": [
        6563
    ],
    "welsh romani": [
        6563
    ],
    "wunda": [
        6568
    ],
    "waima": [
        6599
    ],
    "waruwila": [
        6639
    ],
    "waiangadi": [
        6644
    ],
    "waiangara": [
        6644
    ],
    "waiangari": [
        6644
    ],
    "wain-gara": [
        6644
    ],
    "walmala": [
        6644,
        8187,
        8329
    ],
    "wanayaga": [
        6644
    ],
    "warangari": [
        6644
    ],
    "waringari": [
        6644,
        8187
    ],
    "wommana": [
        6644
    ],
    "woneiga": [
        6644
    ],
    "wahai": [
        6681,
        8224
    ],
    "waya-waya": [
        6809
    ],
    "western sudanic arabic": [
        6855,
        6856
    ],
    "wali banuah": [
        6919
    ],
    "wali": [
        8261,
        8269,
        6919
    ],
    "wono": [
        6936
    ],
    "whulshootseed": [
        6946
    ],
    "wakkore": [
        7000,
        7001
    ],
    "wankara": [
        7000,
        7001
    ],
    "waina-sowanda": [
        7045
    ],
    "wanja": [
        7045
    ],
    "wanya": [
        7045
    ],
    "wasonjo": [
        7048
    ],
    "watemi": [
        7048
    ],
    "western oriya": [
        7066
    ],
    "waray sorsogon": [
        7121
    ],
    "waray": [
        8341,
        7121,
        8165,
        8166
    ],
    "wia": [
        7138
    ],
    "witi": [
        7138
    ],
    "wiya": [
        7138
    ],
    "western sisaala": [
        7140
    ],
    "waata": [
        7142
    ],
    "waat": [
        7142
    ],
    "wasanye": [
        7142
    ],
    "west central goe": [
        7167
    ],
    "western subanon": [
        7189
    ],
    "wagarabai": [
        7191
    ],
    "wiram": [
        7192
    ],
    "wullili": [
        7247
    ],
    "weda": [
        7294,
        8070
    ],
    "weda-sawai": [
        7294
    ],
    "were": [
        7294,
        8075,
        8207
    ],
    "wa’ikhana": [
        7321
    ],
    "wagow": [
        7361
    ],
    "wára": [
        7363
    ],
    "wärä": [
        7363
    ],
    "west torres": [
        7371
    ],
    "western tamang": [
        7390,
        7391
    ],
    "wamia": [
        7421
    ],
    "wakhe": [
        7472
    ],
    "wada thuri": [
        7485
    ],
    "wada": [
        7485,
        8354
    ],
    "wuurong": [
        7531
    ],
    "wurong": [
        7531
    ],
    "wurrong": [
        7531
    ],
    "wikang tagalog": [
        7556,
        7557,
        7558,
        7559
    ],
    "wakut": [
        7577,
        8186
    ],
    "wolu": [
        7580
    ],
    "waibuk": [
        7590
    ],
    "wiyau": [
        7590,
        8244
    ],
    "wiyaw": [
        7590
    ],
    "wovan": [
        7590
    ],
    "western tunebo": [
        7616
    ],
    "wagimuda": [
        7620
    ],
    "whitesands": [
        7627
    ],
    "whitsands": [
        7627
    ],
    "western nyasa": [
        7643
    ],
    "wíꞌi̱i̱n": [
        7669,
        7680
    ],
    "wí’ìn": [
        7680
    ],
    "wí’ììn": [
        7680
    ],
    "western tlapanec": [
        7680
    ],
    "wasoi": [
        7682
    ],
    "warm springs": [
        7686
    ],
    "warm": [
        7686
    ],
    "western totonac": [
        7691
    ],
    "wat": [
        7778
    ],
    "wiarumus": [
        7781
    ],
    "western taubuid": [
        7819
    ],
    "western tawbuid": [
        7819
    ],
    "white tai": [
        7825,
        7826
    ],
    "wateve": [
        7837
    ],
    "west tarangan": [
        7849
    ],
    "west trangan": [
        7849
    ],
    "wu-laya": [
        7869
    ],
    "white tay": [
        7872,
        7873
    ],
    "wamoé": [
        7893
    ],
    "wuzlam": [
        7910
    ],
    "weiwu’er": [
        7916,
        7917,
        7918
    ],
    "wiga": [
        7916,
        7917,
        7918
    ],
    "woolwa": [
        7955
    ],
    "wuningak": [
        7994
    ],
    "wakoro": [
        7997
    ],
    "warpok": [
        8012
    ],
    "warpu": [
        8012
    ],
    "western duka": [
        8020
    ],
    "western dukawa": [
        8020
    ],
    "wu blang": [
        8032
    ],
    "west uvean": [
        8033
    ],
    "wagri vel": [
        8045
    ],
    "wagri": [
        8045,
        8189
    ],
    "wogri boli": [
        8045
    ],
    "wogri": [
        8045
    ],
    "wanimo": [
        8054
    ],
    "walman": [
        8055
    ],
    "warijio": [
        8058
    ],
    "warihó": [
        8058
    ],
    "warli": [
        8062,
        8063
    ],
    "wayo": [
        8064
    ],
    "weddo": [
        8070
    ],
    "west flemish": [
        8103
    ],
    "west vlaams": [
        8103
    ],
    "west-vlams": [
        8103
    ],
    "west-vloams": [
        8103
    ],
    "western flemish": [
        8103
    ],
    "westvlams": [
        8103
    ],
    "woombarbarram": [
        8105
    ],
    "wumbabaram": [
        8105
    ],
    "west makua": [
        8114
    ],
    "waluridji": [
        8121
    ],
    "woro": [
        8132
    ],
    "wunjo": [
        8144
    ],
    "wetere": [
        8145
    ],
    "woute": [
        8145
    ],
    "wute": [
        8145
    ],
    "walloon": [
        8147
    ],
    "walon": [
        8147
    ],
    "wallon": [
        8147
    ],
    "walla walla": [
        8148
    ],
    "walla": [
        8148
    ],
    "wab": [
        8149
    ],
    "wasco-wishram": [
        8150
    ],
    "wasco": [
        8150
    ],
    "wishram": [
        8150
    ],
    "wamesa": [
        8151
    ],
    "wandamen": [
        8151
    ],
    "wandamen-windesi": [
        8151
    ],
    "wondama": [
        8151
    ],
    "walser": [
        8152
    ],
    "walscher": [
        8152
    ],
    "wakoná": [
        8153
    ],
    "wa’ema": [
        8154
    ],
    "wa'ema": [
        8154
    ],
    "waiema": [
        8154
    ],
    "watubela": [
        8155
    ],
    "wesi": [
        8155
    ],
    "wares": [
        8156
    ],
    "waffa": [
        8157
    ],
    "wolaytta": [
        8158,
        8159
    ],
    "wampanoag": [
        8160
    ],
    "wôpanâak": [
        8160
    ],
    "wappo": [
        8162
    ],
    "wapishana": [
        8163
    ],
    "wapichan": [
        8163
    ],
    "wapichana": [
        8163
    ],
    "wapisana": [
        8163
    ],
    "wapishiana": [
        8163
    ],
    "wapishshiana": [
        8163
    ],
    "wapisiana": [
        8163
    ],
    "wapitxana": [
        8163
    ],
    "wapixana": [
        8163
    ],
    "wapixiana": [
        8163
    ],
    "wapixiána": [
        8163
    ],
    "wapixána": [
        8163
    ],
    "wagiman": [
        8164
    ],
    "wagaman": [
        8164
    ],
    "wageman": [
        8164
    ],
    "wagoman": [
        8164
    ],
    "wakiman": [
        8164
    ],
    "wogeman": [
        8164
    ],
    "waray-waray": [
        8165,
        8166
    ],
    "waray (philippines)": [
        8165,
        8166
    ],
    "winaray": [
        8165,
        8166
    ],
    "washo": [
        8167
    ],
    "washoe": [
        8167
    ],
    "wá:šiw ʔítlu": [
        8167
    ],
    "wášiw": [
        8167
    ],
    "wataluma": [
        8168
    ],
    "waurá": [
        8169
    ],
    "waujá": [
        8169
    ],
    "waurá-meinaku": [
        8169
    ],
    "waka": [
        8170,
        8252
    ],
    "waiwai": [
        8171
    ],
    "wai wai": [
        8171
    ],
    "watam": [
        8172
    ],
    "wayana": [
        8173
    ],
    "waiana": [
        8173
    ],
    "wajana": [
        8173
    ],
    "wayâna": [
        8173
    ],
    "wampur": [
        8174
    ],
    "wampul": [
        8174
    ],
    "warao": [
        8175
    ],
    "warau": [
        8175
    ],
    "warrau": [
        8175
    ],
    "wabo": [
        8176
    ],
    "woriasi": [
        8176
    ],
    "waritai": [
        8177
    ],
    "weretai": [
        8177
    ],
    "wandia": [
        8179
    ],
    "waasi": [
        8181
    ],
    "waigali": [
        8182
    ],
    "wai-ala": [
        8182
    ],
    "waigala": [
        8182
    ],
    "waigalii": [
        8182
    ],
    "waigeli": [
        8182
    ],
    "wakhi": [
        8183,
        8184,
        8185
    ],
    "wakhani": [
        8183,
        8184,
        8185
    ],
    "wakhigi": [
        8183,
        8184,
        8185
    ],
    "wa, vo": [
        8186
    ],
    "wa pwi": [
        8186
    ],
    "warlpiri": [
        8187
    ],
    "waibry": [
        8187
    ],
    "wailbri": [
        8187
    ],
    "walbiri": [
        8187
    ],
    "walbrai": [
        8187
    ],
    "walbri": [
        8187
    ],
    "waljbiri": [
        8187
    ],
    "waljpiri": [
        8187
    ],
    "walmama": [
        8187
    ],
    "walmanba": [
        8187
    ],
    "walpari": [
        8187
    ],
    "walpiri": [
        8187
    ],
    "wanaeka": [
        8187
    ],
    "wanajaga": [
        8187
    ],
    "wanajaka": [
        8187
    ],
    "wanajeka": [
        8187
    ],
    "waneiga": [
        8187
    ],
    "wolperi": [
        8187
    ],
    "wolpirra": [
        8187
    ],
    "waddar": [
        8188
    ],
    "werders": [
        8188
    ],
    "wodde": [
        8188
    ],
    "wagdi": [
        8189
    ],
    "wagadi": [
        8189
    ],
    "wagari": [
        8189
    ],
    "waghari": [
        8189
    ],
    "wagholi": [
        8189
    ],
    "west bengal sign language": [
        8190
    ],
    "w.b. sign language": [
        8190
    ],
    "wb": [
        8190
    ],
    "wbsl": [
        8190
    ],
    "warnman": [
        8191
    ],
    "wanman": [
        8191
    ],
    "wajarri": [
        8192
    ],
    "wadjari": [
        8192
    ],
    "wadjeri": [
        8192
    ],
    "watjari": [
        8192
    ],
    "watjarri": [
        8192
    ],
    "woi": [
        8193
    ],
    "wo’oi": [
        8193
    ],
    "waica": [
        8194
    ],
    "waiká": [
        8194
    ],
    "waci": [
        8195
    ],
    "waci gbe": [
        8195
    ],
    "waci-gbe": [
        8195
    ],
    "watyi": [
        8195
    ],
    "watyu": [
        8195
    ],
    "wandji": [
        8196
    ],
    "wanzi": [
        8196
    ],
    "wadaginam": [
        8197
    ],
    "wadaginamb": [
        8197
    ],
    "wadjiginy": [
        8198
    ],
    "wadiginy": [
        8198
    ],
    "wadyiginy": [
        8198
    ],
    "wagaydy": [
        8198
    ],
    "wogaity": [
        8198
    ],
    "wadikali": [
        8199
    ],
    "wadigali": [
        8199
    ],
    "wadjigu": [
        8200
    ],
    "wadja": [
        8200
    ],
    "wadjainggo": [
        8200
    ],
    "wadjingu": [
        8200
    ],
    "waindjago": [
        8200
    ],
    "wainggo": [
        8200
    ],
    "wainjago": [
        8200
    ],
    "wainjigo": [
        8200
    ],
    "wadjabangayi": [
        8201
    ],
    "wadjabangai": [
        8201
    ],
    "wadjabangay": [
        8201
    ],
    "wewaw": [
        8202
    ],
    "wewau": [
        8202
    ],
    "wè western": [
        8203
    ],
    "wedau": [
        8204
    ],
    "wamira": [
        8204
    ],
    "wedaun": [
        8204
    ],
    "wedawan": [
        8204
    ],
    "wergaia": [
        8205
    ],
    "wergaya": [
        8205
    ],
    "werkaya": [
        8205
    ],
    "wimmera": [
        8205
    ],
    "worgaia": [
        8205,
        8217
    ],
    "weh": [
        8206
    ],
    "wi": [
        8206
    ],
    "weredai": [
        8207
    ],
    "weme": [
        8208
    ],
    "weme gbe": [
        8208
    ],
    "weme-gbe": [
        8208
    ],
    "wéménugbé": [
        8208
    ],
    "wemale": [
        8209
    ],
    "westphalien": [
        8210
    ],
    "westfaelisch": [
        8210
    ],
    "westfalish": [
        8210
    ],
    "westfälisch": [
        8210
    ],
    "westfäölsk": [
        8210
    ],
    "westfäölsk plat": [
        8210
    ],
    "westfäölsk platt": [
        8210
    ],
    "westphalish": [
        8210
    ],
    "wele": [
        8211,
        8261
    ],
    "weli": [
        8211
    ],
    "wes cos": [
        8212
    ],
    "welaung": [
        8214
    ],
    "wejewa": [
        8215
    ],
    "waidjewa": [
        8215
    ],
    "wajewa": [
        8215
    ],
    "west sumbanese": [
        8215
    ],
    "wewewa": [
        8215
    ],
    "wewjewa": [
        8215
    ],
    "weyewa": [
        8215
    ],
    "wagarindem": [
        8216
    ],
    "wargarindem": [
        8216
    ],
    "warlef": [
        8216
    ],
    "wagaya": [
        8217
    ],
    "waagai": [
        8217
    ],
    "waagi": [
        8217
    ],
    "wagai": [
        8217
    ],
    "wagaja": [
        8217
    ],
    "waggaia": [
        8217
    ],
    "wakaja": [
        8217
    ],
    "wakaya": [
        8217
    ],
    "wakkaja": [
        8217
    ],
    "warkya": [
        8217
    ],
    "worgai": [
        8217
    ],
    "workia": [
        8217
    ],
    "wagawaga": [
        8218,
        8252
    ],
    "wangkangurru": [
        8219
    ],
    "wangganguru": [
        8219
    ],
    "wangka-jutjuru": [
        8219,
        8253
    ],
    "wangka-yutjurru": [
        8219,
        8253
    ],
    "wangkadjera": [
        8219
    ],
    "wangkanguru": [
        8219
    ],
    "wonggongaru": [
        8219
    ],
    "wongkanguru": [
        8219
    ],
    "wongkongaru": [
        8219
    ],
    "wongonooroo": [
        8219
    ],
    "wonkagnurra": [
        8219
    ],
    "wonkaoora": [
        8219
    ],
    "wonkaooroo": [
        8219
    ],
    "wonkongaru": [
        8219
    ],
    "wonkongnuru": [
        8219
    ],
    "wonkonguru": [
        8219
    ],
    "wychinga": [
        8219
    ],
    "wahgi": [
        8220,
        8225
    ],
    "waigeo": [
        8221
    ],
    "waigiu": [
        8221
    ],
    "wirangu": [
        8222
    ],
    "wanbiri": [
        8222
    ],
    "wangon": [
        8222
    ],
    "warrangoo": [
        8222,
        8465
    ],
    "willeuroo": [
        8222
    ],
    "windakan": [
        8222
    ],
    "wirangga": [
        8222
    ],
    "wirongu": [
        8222
    ],
    "wironguwongga": [
        8222
    ],
    "wirrongu": [
        8222
    ],
    "wirrung": [
        8222
    ],
    "wirrunga": [
        8222
    ],
    "warrgamay": [
        8223
    ],
    "wargamay": [
        8223
    ],
    "wahinama": [
        8224
    ],
    "we": [
        8225
    ],
    "wahau": [
        8226,
        8227
    ],
    "wahau kenya": [
        8226
    ],
    "wahau kenyah": [
        8226
    ],
    "wahau kajan": [
        8227
    ],
    "wahau kayan": [
        8227
    ],
    "wĩ́nwɛ́y": [
        8228
    ],
    "wichita": [
        8229
    ],
    "wik-epa": [
        8230
    ],
    "wik epa": [
        8230
    ],
    "wik": [
        8232,
        8230,
        8235,
        8236,
        8238,
        8360,
        8538
    ],
    "wik-ep": [
        8230
    ],
    "wik-eppa": [
        8230
    ],
    "wikepa": [
        8230
    ],
    "wik-keyangan": [
        8231
    ],
    "wik ngathan": [
        8232
    ],
    "wik-ngathana": [
        8232
    ],
    "wik-me’anha": [
        8233
    ],
    "wik-em’an": [
        8233
    ],
    "wik-me'anha": [
        8233
    ],
    "wik-me’anh": [
        8233
    ],
    "wik-me’nh": [
        8233
    ],
    "wikmean": [
        8233
    ],
    "wiakei": [
        8234
    ],
    "wiaki": [
        8234
    ],
    "wik-iiyanh": [
        8235
    ],
    "wik iyanh": [
        8235
    ],
    "wik iyanja": [
        8235
    ],
    "wikalkan": [
        8236
    ],
    "wik alkan": [
        8236
    ],
    "wik elken": [
        8236
    ],
    "wik-alkanh": [
        8236
    ],
    "wik-kalkan": [
        8236
    ],
    "wik-ngathara": [
        8236
    ],
    "wik-ngatharra": [
        8236
    ],
    "wik-ngathrr": [
        8236
    ],
    "wikngatara": [
        8236
    ],
    "wilawila": [
        8237
    ],
    "wila-wila": [
        8237
    ],
    "wik-mungkan": [
        8238
    ],
    "wik-mungknh": [
        8238
    ],
    "wik munggan": [
        8238
    ],
    "wik-mungkana": [
        8238
    ],
    "wik-munkan": [
        8238
    ],
    "wazijaci": [
        8239
    ],
    "winnebago": [
        8239
    ],
    "wirafed": [
        8240
    ],
    "wiroféd": [
        8240
    ],
    "wiru": [
        8241
    ],
    "wiyot": [
        8243
    ],
    "weott": [
        8243
    ],
    "weyot": [
        8243
    ],
    "wishosk": [
        8243
    ],
    "wiyoshk": [
        8243
    ],
    "waja": [
        8244
    ],
    "wiyaa": [
        8244
    ],
    "wuya": [
        8244
    ],
    "warji": [
        8245
    ],
    "warja": [
        8245
    ],
    "warjawa": [
        8245
    ],
    "wakde": [
        8248
    ],
    "wakawaka": [
        8252
    ],
    "waga": [
        8252
    ],
    "waga-waga": [
        8252
    ],
    "waka waka": [
        8252
    ],
    "wakka": [
        8252
    ],
    "wangkayutyuru": [
        8253
    ],
    "wanggadjara": [
        8253
    ],
    "wanggadyara": [
        8253
    ],
    "wanggayudyuru": [
        8253
    ],
    "wangka-yutjuru": [
        8253
    ],
    "wangkatjera": [
        8253
    ],
    "wangkayutjuru": [
        8253
    ],
    "wongga-jitjeru": [
        8253
    ],
    "wongga-itjeru": [
        8253
    ],
    "wonggadjara": [
        8253
    ],
    "wongka-itjeru": [
        8253
    ],
    "wongka-itjuru": [
        8253
    ],
    "wongkadjera": [
        8253
    ],
    "wongkatjera": [
        8253
    ],
    "wonkajara": [
        8253
    ],
    "wonkajera": [
        8253
    ],
    "wonkatyeri": [
        8253
    ],
    "wonkoyara": [
        8253
    ],
    "walio": [
        8254
    ],
    "wolane": [
        8256
    ],
    "walang": [
        8257
    ],
    "warlang": [
        8257
    ],
    "welaun": [
        8258
    ],
    "wekais": [
        8258
    ],
    "waioli": [
        8259
    ],
    "wajoli": [
        8259
    ],
    "wayoli": [
        8259
    ],
    "wailaki": [
        8260
    ],
    "walari": [
        8261
    ],
    "walarishe": [
        8261
    ],
    "wali (sudan)": [
        8261
    ],
    "wolio": [
        8263
    ],
    "wailapa": [
        8264
    ],
    "wallisian": [
        8265
    ],
    "wallisien": [
        8265
    ],
    "wuliwuli": [
        8266
    ],
    "wilili": [
        8266
    ],
    "wililililee": [
        8266
    ],
    "willillee": [
        8266
    ],
    "wuli wuli": [
        8266
    ],
    "wuli": [
        8266
    ],
    "wuli-wuli": [
        8266
    ],
    "wulili": [
        8266
    ],
    "wichí lhamtés vejoz": [
        8267
    ],
    "wichi": [
        8267
    ],
    "walak": [
        8268
    ],
    "wodo": [
        8268
    ],
    "waali": [
        8269
    ],
    "waalii": [
        8269
    ],
    "wali (ghana)": [
        8269
    ],
    "wambaya": [
        8272
    ],
    "wambaia": [
        8272
    ],
    "wambaja": [
        8272
    ],
    "wom-by-a": [
        8272
    ],
    "wombya": [
        8272
    ],
    "wamas": [
        8273
    ],
    "wambule": [
        8275
    ],
    "western minyag": [
        8276
    ],
    "waima’a": [
        8277
    ],
    "waima'a": [
        8277
    ],
    "waimoa": [
        8277
    ],
    "wamin": [
        8278
    ],
    "waamwang": [
        8280
    ],
    "wamoang": [
        8280
    ],
    "wom": [
        8281,
        8315
    ],
    "wam": [
        8917,
        8281
    ],
    "wom (papua new guinea)": [
        8281
    ],
    "walmajarri": [
        8283
    ],
    "walmadjari": [
        8283
    ],
    "walmajiri": [
        8283
    ],
    "walmatjari": [
        8283
    ],
    "walmatjarri": [
        8283
    ],
    "walmatjiri": [
        8283
    ],
    "wolmeri": [
        8283
    ],
    "womo": [
        8286
    ],
    "wanambre": [
        8287
    ],
    "wantoat": [
        8288
    ],
    "wandarang": [
        8289
    ],
    "wamdarang": [
        8289
    ],
    "wandaran": [
        8289
    ],
    "warndarang": [
        8289
    ],
    "warndarrang": [
        8289
    ],
    "wuyarrawala": [
        8289
    ],
    "waneci": [
        8290
    ],
    "wanechi": [
        8290
    ],
    "wanetsi": [
        8290
    ],
    "wanggom": [
        8291
    ],
    "wanggo": [
        8291
    ],
    "wangom": [
        8291
    ],
    "wanukaka": [
        8294
    ],
    "wanokaka": [
        8294
    ],
    "wanggamala": [
        8295
    ],
    "wunumara": [
        8296
    ],
    "wanamara": [
        8296
    ],
    "woonamurra": [
        8296
    ],
    "woonomurra": [
        8296
    ],
    "wunamara": [
        8296
    ],
    "wunumura": [
        8296
    ],
    "wano": [
        8297
    ],
    "waano": [
        8297
    ],
    "wanap": [
        8298
    ],
    "wanuma": [
        8299
    ],
    "waanyi": [
        8301
    ],
    "waangyee": [
        8301
    ],
    "wainyi": [
        8301
    ],
    "wanee": [
        8301
    ],
    "wanyee": [
        8301
    ],
    "wanyi": [
        8301
    ],
    "wonyee": [
        8301
    ],
    "wolof": [
        8302,
        8303,
        8310,
        8311
    ],
    "walaf": [
        8302,
        8303
    ],
    "waro-waro": [
        8302,
        8303
    ],
    "wè northern": [
        8305
    ],
    "wɛɛ": [
        8305
    ],
    "wobé": [
        8305
    ],
    "wogeo": [
        8306
    ],
    "wolani": [
        8307
    ],
    "woda": [
        8307
    ],
    "woda-mo": [
        8307
    ],
    "wodani": [
        8307
    ],
    "woleaian": [
        8308,
        8309
    ],
    "wolof, gambian": [
        8310,
        8311
    ],
    "wogamusin": [
        8312
    ],
    "wongamusin": [
        8312
    ],
    "waisika": [
        8313
    ],
    "woisika": [
        8313
    ],
    "woko": [
        8314
    ],
    "wom (nigeria)": [
        8315
    ],
    "wongo": [
        8316
    ],
    "wonk": [
        8316
    ],
    "wamar": [
        8317
    ],
    "wokam": [
        8317
    ],
    "woria": [
        8318
    ],
    "west wosera": [
        8319
    ],
    "wawonii": [
        8320
    ],
    "wowonii": [
        8320
    ],
    "weyto": [
        8321
    ],
    "wirö": [
        8322
    ],
    "wirú": [
        8322
    ],
    "wotuja": [
        8322
    ],
    "waluwarra": [
        8323
    ],
    "walookera": [
        8323
    ],
    "walugera": [
        8323
    ],
    "waluwara": [
        8323
    ],
    "warluwara": [
        8323
    ],
    "warluwarra": [
        8323
    ],
    "wollegara": [
        8323
    ],
    "warduji": [
        8324
    ],
    "warungu": [
        8325
    ],
    "warrongo": [
        8325
    ],
    "warrungu": [
        8325
    ],
    "wiradjuri": [
        8326
    ],
    "warandgeri": [
        8326
    ],
    "werogery": [
        8326
    ],
    "wiiratheri": [
        8326
    ],
    "wira-athoree": [
        8326
    ],
    "wiradhuri": [
        8326
    ],
    "wiradhurri": [
        8326
    ],
    "wiraduri": [
        8326
    ],
    "wiraidyuri": [
        8326
    ],
    "wirajeree": [
        8326
    ],
    "wirashuri": [
        8326
    ],
    "wiratheri": [
        8326
    ],
    "wirracharee": [
        8326
    ],
    "wirrai’yarrai": [
        8326
    ],
    "wooragurie": [
        8326
    ],
    "wordjerg": [
        8326
    ],
    "wariyangga": [
        8327
    ],
    "warriyangka": [
        8327
    ],
    "wollongorang": [
        8328
    ],
    "wulungwara": [
        8328
    ],
    "warlmanpa": [
        8329
    ],
    "warumungu": [
        8330
    ],
    "waramunga": [
        8330
    ],
    "waramungu": [
        8330
    ],
    "warramunga": [
        8330
    ],
    "warnang": [
        8331
    ],
    "werni": [
        8331
    ],
    "worrorra": [
        8332
    ],
    "worora": [
        8332
    ],
    "wororra": [
        8332
    ],
    "worrara": [
        8332
    ],
    "worrora": [
        8332
    ],
    "wurara": [
        8332
    ],
    "wurora": [
        8332
    ],
    "waropen": [
        8333
    ],
    "wonti": [
        8333
    ],
    "worpen": [
        8333
    ],
    "wardaman": [
        8334
    ],
    "wadaman": [
        8334
    ],
    "waderman": [
        8334
    ],
    "waduman": [
        8334
    ],
    "warda’man": [
        8334
    ],
    "wardman": [
        8334
    ],
    "warduman": [
        8334
    ],
    "wartaman": [
        8334
    ],
    "wordaman": [
        8334
    ],
    "waris": [
        8335
    ],
    "walsa": [
        8335
    ],
    "waru": [
        8336
    ],
    "waruna": [
        8337
    ],
    "wae rana": [
        8339
    ],
    "wae": [
        8339
    ],
    "waerana": [
        8339
    ],
    "waray (australia)": [
        8341
    ],
    "warrai": [
        8341
    ],
    "warray": [
        8341
    ],
    "warembori": [
        8342
    ],
    "waremboivoro": [
        8342
    ],
    "warenbori": [
        8342
    ],
    "wusi": [
        8347
    ],
    "wusi-kerepua": [
        8347
    ],
    "waskia": [
        8348
    ],
    "woskia": [
        8348
    ],
    "waijara": [
        8349
    ],
    "waisara": [
        8349
    ],
    "wasa": [
        8350
    ],
    "wasaw": [
        8350
    ],
    "wassa": [
        8350
    ],
    "wasu": [
        8351
    ],
    "wassu": [
        8351
    ],
    "wassú": [
        8351
    ],
    "waçu": [
        8351
    ],
    "wotapuri-katarqalai": [
        8352
    ],
    "watiwa": [
        8353
    ],
    "watifa": [
        8353
    ],
    "wathawurrung": [
        8354
    ],
    "wada wurrung": [
        8354
    ],
    "wadawio": [
        8354
    ],
    "waddorow": [
        8354
    ],
    "wadhaurung": [
        8354
    ],
    "wadjawuru": [
        8354
    ],
    "wadourer": [
        8354
    ],
    "wadthaurung": [
        8354
    ],
    "waitowrung": [
        8354
    ],
    "wathaurong": [
        8354
    ],
    "wathaurung": [
        8354
    ],
    "wathawurung": [
        8354
    ],
    "wathurung": [
        8354
    ],
    "watorrong": [
        8354
    ],
    "wiityahuurong": [
        8354
    ],
    "wioura": [
        8354
    ],
    "witaoro": [
        8354
    ],
    "witawurong": [
        8354
    ],
    "witoura": [
        8354
    ],
    "witouro": [
        8354
    ],
    "witowro": [
        8354
    ],
    "witowurong": [
        8354
    ],
    "witowurrong": [
        8354
    ],
    "witowurrung": [
        8354
    ],
    "witowurung": [
        8354
    ],
    "wittyawhuurong": [
        8354
    ],
    "wod-dowrong": [
        8354
    ],
    "woddowro": [
        8354
    ],
    "woddowrong": [
        8354
    ],
    "wollowurong": [
        8354
    ],
    "wooeewoorong": [
        8354,
        8384
    ],
    "wothowurong": [
        8354
    ],
    "wuddyawurra": [
        8354
    ],
    "wuddyawurru": [
        8354
    ],
    "wudja-wurung": [
        8354
    ],
    "wudjawuru": [
        8354
    ],
    "wudjawurung": [
        8354
    ],
    "wudthaurung": [
        8354
    ],
    "watakataui": [
        8356
    ],
    "waxe": [
        8356
    ],
    "wotu": [
        8358,
        8359
    ],
    "wadu": [
        8358,
        8359
    ],
    "wikngenchera": [
        8360
    ],
    "wik-nantjara": [
        8360
    ],
    "wumnabal": [
        8361
    ],
    "wunambul": [
        8361
    ],
    "wunambullu": [
        8361
    ],
    "wudu": [
        8362
    ],
    "wutunhua": [
        8363
    ],
    "wutong": [
        8363
    ],
    "wutun": [
        8363
    ],
    "wulik": [
        8364
    ],
    "wumbvu": [
        8365
    ],
    "wumbu": [
        8365
    ],
    "wumvu": [
        8365
    ],
    "wungu": [
        8366
    ],
    "wurrugu": [
        8367
    ],
    "wutung": [
        8368
    ],
    "wu chinese": [
        8369,
        8370,
        8371
    ],
    "wu gniu": [
        8369,
        8370,
        8371
    ],
    "wu nyu": [
        8369,
        8370,
        8371
    ],
    "wuyue": [
        8369,
        8370,
        8371
    ],
    "wúyuèyǔ": [
        8369,
        8370,
        8371
    ],
    "wuvulu-aua": [
        8372
    ],
    "wulna": [
        8373
    ],
    "wauyai": [
        8374
    ],
    "waama": [
        8375
    ],
    "wakabunga": [
        8376
    ],
    "waggaboonyah": [
        8376
    ],
    "waggabundi": [
        8376
    ],
    "wakobungo": [
        8376
    ],
    "waukaboonia": [
        8376
    ],
    "worgabunga": [
        8376
    ],
    "workabunga": [
        8376
    ],
    "workoboongo": [
        8376
    ],
    "wetamut": [
        8377
    ],
    "warrwa": [
        8378
    ],
    "warrawai": [
        8378
    ],
    "warwa": [
        8378
    ],
    "waxianghua": [
        8380
    ],
    "wogang": [
        8380
    ],
    "wardandi": [
        8381
    ],
    "waadandi": [
        8381
    ],
    "waddarndi": [
        8381
    ],
    "wadjandi": [
        8381
    ],
    "wyandot": [
        8382
    ],
    "wendat": [
        8382
    ],
    "wyandotte": [
        8382
    ],
    "wyendat": [
        8382
    ],
    "wangaaybuwan-ngiyambaa": [
        8383
    ],
    "woiwurrung": [
        8384
    ],
    "waarengbadawa": [
        8384
    ],
    "wainworra": [
        8384
    ],
    "wairwaioo": [
        8384
    ],
    "warerong": [
        8384
    ],
    "warorong": [
        8384
    ],
    "warwaroo": [
        8384
    ],
    "waverong": [
        8384
    ],
    "wavoo-rong": [
        8384
    ],
    "wawoo-rong": [
        8384
    ],
    "wawoorong": [
        8384
    ],
    "wawurong": [
        8384
    ],
    "wawurrong": [
        8384
    ],
    "woewo-rung": [
        8384
    ],
    "woi-wurrong": [
        8384
    ],
    "woiworung": [
        8384
    ],
    "woiwurong": [
        8384
    ],
    "woiwurru": [
        8384
    ],
    "woiwurung": [
        8384
    ],
    "wowerong": [
        8384
    ],
    "wurrundyirra-baluk": [
        8384
    ],
    "wurrunjeri": [
        8384
    ],
    "wurundjeri": [
        8384
    ],
    "wurunjeri": [
        8384
    ],
    "wurunjerri-baluk": [
        8384
    ],
    "wuywurrung": [
        8384
    ],
    "wymysorys": [
        8385
    ],
    "wilamowicean": [
        8385
    ],
    "wymysiöeryś": [
        8385
    ],
    "wayoró": [
        8386
    ],
    "wajaru": [
        8386
    ],
    "wayurú": [
        8386
    ],
    "western fijian": [
        8387
    ],
    "wrong": [
        8388
    ],
    "weilate": [
        8398,
        8399
    ],
    "western mongol": [
        8398,
        8399
    ],
    "western mongolian": [
        8398,
        8399
    ],
    "warangu": [
        8465
    ],
    "warranger": [
        8465
    ],
    "warrangle": [
        8465
    ],
    "wongkomi": [
        8470
    ],
    "western kenya": [
        8514
    ],
    "western kenyah": [
        8514
    ],
    "wawoi": [
        8517
    ],
    "wik muminh": [
        8538
    ],
    "wik-mumin": [
        8538
    ],
    "western bontoc": [
        8564
    ],
    "wumide": [
        8673
    ],
    "wonnawal": [
        8676
    ],
    "woccon": [
        8691
    ],
    "wadi wadi": [
        8692
    ],
    "wadi": [
        8692
    ],
    "wathiwathi": [
        8692
    ],
    "wattewatte": [
        8692
    ],
    "watthiwatthi": [
        8692
    ],
    "watty-watty": [
        8692
    ],
    "withaija": [
        8692
    ],
    "woani": [
        8692
    ],
    "wohdi wohdi": [
        8692
    ],
    "wohdi": [
        8692
    ],
    "woonyi": [
        8692
    ],
    "wotti-wotti": [
        8692
    ],
    "wajuk": [
        8695
    ],
    "wongi": [
        8695
    ],
    "wadjug": [
        8695
    ],
    "wadjuk": [
        8695
    ],
    "wadjup": [
        8695
    ],
    "wadyuk": [
        8695
    ],
    "whadjuk": [
        8695
    ],
    "whajook": [
        8695
    ],
    "witjaari": [
        8695
    ],
    "wangkumara": [
        8696
    ],
    "wanggumara": [
        8696
    ],
    "wanghumara": [
        8696
    ],
    "wangumarra": [
        8696
    ],
    "wongkumara": [
        8696
    ],
    "western xwla gbe": [
        8697
    ],
    "written oirat": [
        8698
    ],
    "written": [
        8698
    ],
    "wotjobaluk": [
        8700
    ],
    "watjo": [
        8700
    ],
    "wattyabullak": [
        8700
    ],
    "woitu-bullar": [
        8700
    ],
    "wotjbaluk": [
        8700
    ],
    "wotjo": [
        8700
    ],
    "wotjo-ba-laiuruk": [
        8700
    ],
    "wotjo-balluk": [
        8700
    ],
    "wotjo-baluk": [
        8700
    ],
    "wotjobalak": [
        8700
    ],
    "wotjobalek": [
        8700
    ],
    "wotjoballaiuk": [
        8700
    ],
    "wotjoballuck": [
        8700
    ],
    "wotjoballuk": [
        8700
    ],
    "wotjobolak": [
        8700
    ],
    "wotjobuluk": [
        8700
    ],
    "woychibirik": [
        8700
    ],
    "wudjubalug": [
        8700
    ],
    "wudjubaluk": [
        8700
    ],
    "wutjubaluk": [
        8700
    ],
    "wuttyabullak": [
        8700
    ],
    "wuttyubullak": [
        8700
    ],
    "wutyuballeak": [
        8700
    ],
    "wemba wemba": [
        8701
    ],
    "waamba": [
        8701
    ],
    "waimbiwaimbi": [
        8701
    ],
    "wamba": [
        8701
    ],
    "wamba wamba": [
        8701
    ],
    "wambawamba": [
        8701
    ],
    "wembawemba": [
        8701
    ],
    "weumba": [
        8701
    ],
    "womba": [
        8701
    ],
    "wol-lithiga": [
        8713
    ],
    "woollathura": [
        8713
    ],
    "western yali": [
        8719
    ],
    "waptailmim": [
        8728
    ],
    "wajao": [
        8733,
        8734
    ],
    "wayao": [
        8733,
        8734
    ],
    "wa’ab": [
        8735
    ],
    "waab": [
        8735
    ],
    "waruwaru": [
        8740
    ],
    "west yugur": [
        8748,
        8749
    ],
    "wigal yeri": [
        8779
    ],
    "wigal": [
        8779
    ],
    "wayeyi": [
        8780
    ],
    "western buyang": [
        8790
    ],
    "wusa": [
        8797,
        8953
    ],
    "wusa nasu": [
        8797
    ],
    "wusa nesu": [
        8797
    ],
    "western yiddish": [
        8798
    ],
    "warra-warra": [
        8799
    ],
    "warryboora": [
        8799
    ],
    "woggil": [
        8799
    ],
    "wadul": [
        8816
    ],
    "wonkorok": [
        8880
    ],
    "white phu": [
        8884
    ],
    "waengatu": [
        8896
    ],
    "white yi": [
        8913
    ],
    "wancheng": [
        8923,
        8924,
        8925,
        8926
    ],
    "wajiara": [
        8929
    ],
    "wadzana": [
        8929
    ],
    "waijiara masa-wadyana": [
        8929
    ],
    "waijiara": [
        8929
    ],
    "waikana": [
        8929
    ],
    "waimasá": [
        8929
    ],
    "wajiaraye": [
        8929
    ],
    "wayhara": [
        8929
    ],
    "weitspek": [
        8937
    ],
    "weitspekan": [
        8937
    ],
    "western lalu": [
        8947
    ],
    "wuding-luquan": [
        8949,
        8950
    ],
    "wu-lu yi": [
        8949,
        8950
    ],
    "wu-lu": [
        8949,
        8950
    ],
    "wuding-luquan yi": [
        8949,
        8950
    ],
    "western yi": [
        8952
    ],
    "wumeng": [
        8953
    ],
    "wumeng nasu": [
        8953
    ],
    "wumeng yi": [
        8953
    ],
    "wusa yi": [
        8953
    ],
    "willoo": [
        8959
    ],
    "wilu": [
        8959
    ],
    "waningotbun": [
        8960
    ],
    "western tlacolula valley zapotec": [
        8970
    ],
    "western tlacolula zapotec": [
        8970
    ],
    "western ixtlán zapotec": [
        8973
    ],
    "western ejutla zapotec": [
        8974
    ],
    "west berawan": [
        9002
    ],
    "wen-ma southern zhuang": [
        9044,
        9045
    ],
    "wen-ma": [
        9044,
        9045
    ],
    "waria": [
        9051
    ],
    "wayombo": [
        9057
    ],
    "wazegua": [
        9057
    ],
    "wakanuwan": [
        9071
    ],
    "warrah": [
        9071
    ],
    "widninga": [
        9071
    ],
    "winaini": [
        9071
    ],
    "winnay-nie": [
        9071
    ],
    "winnaynie": [
        9071
    ],
    "wa-zula": [
        9074
    ],
    "warat": [
        9092
    ],
    "warrgat": [
        9098
    ],
    "western zimatlán zapotec": [
        9127
    ],
    "western yautepec zapotec": [
        9128
    ],
    "western miahuatlán zapotec": [
        9138
    ],
    "wlhàll": [
        9140
    ],
    "western sola de vega zapotec": [
        9142
    ],
    "wapu": [
        9159
    ],
    "western pochutla zapotec": [
        9165
    ]
};
